import { IDataSource } from 'core-components/types/ICrudHelpers'

export const jbpMarketLeasingDataSource: IDataSource = {
  formId: '1018',
  code: 'JBPMarketLeasing',
}
